// Enlaces para compartir (partials/comunes/compartir.sbn).
// Completa cada enlace con la URL de la página y el texto de data-texto. Sustituye a los
// onclick que incrustaban el título dentro de JavaScript (se rompían con un apóstrofo).

type Constructor = (url: string, texto: string) => string;

const REDES: Record<string, Constructor> = {
  facebook: (url) => `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  x: (url, texto) => `https://twitter.com/intent/tweet?url=${url}&text=${texto}`,
  linkedin: (url) => `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
  whatsapp: (url, texto) => `https://wa.me/?text=${texto}%20${url}`,
  telegram: (url, texto) => `https://telegram.me/share/url?url=${url}&text=${texto}`,
  email: (url, texto) => `mailto:?subject=${texto}&body=${texto}%0D%0A%0D%0A${url}`,
};

export const initCompartir = (root?: HTMLElement) => {
  if (!root) return;

  const url = encodeURIComponent(window.location.href);
  const texto = encodeURIComponent(root.dataset.texto || document.title);

  root.querySelectorAll<HTMLAnchorElement>('a[data-red]').forEach((enlace) => {
    const construir = REDES[enlace.dataset.red ?? ''];
    if (construir) enlace.href = construir(url, texto);
  });
};
